import styled from 'styled-components';
import { theme } from '@gympass/yoga';
import { media } from '@gympass/yoga-helpers';

const { colors, spacing, radii } = theme;

export const CopyContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: ${spacing.medium}px 55px;
  border-radius: ${radii.small}px;
  background-color: ${colors.clear};

  ${media.lg`
    margin-top: 0;
  `};
`;

export const IconWrapper = styled.div`
  color: ${colors.primary};
  margin-left: 17px;
  width: 22px;
  height: 22px;
  cursor: pointer;
`;
